/* LDF Sala — JS globale minimo */
(function(){
  var nav=document.querySelector('.ldf-nav');
  var tg=document.querySelector('.ldf-nav-toggle');
  if(tg&&nav){tg.addEventListener('click',function(){nav.classList.toggle('open');tg.setAttribute('aria-expanded',nav.classList.contains('open'))});}
  if(document.querySelector('.ldf-sticky')){document.body.classList.add('has-sticky');}
  var pref=document.getElementById('ldf-cookie-prefs');
  if(pref){pref.addEventListener('click',function(){
    if(window.privacyBanner&&window.privacyBanner.showPreferences){window.privacyBanner.showPreferences();return;}
    if(window.Shopify&&window.Shopify.customerPrivacy&&window.Shopify.customerPrivacy.showPreferences){window.Shopify.customerPrivacy.showPreferences();return;}
    window.location.href=(document.documentElement.lang==='en'?'/en/pages/cookie-policy':'/pages/cookie-policy');
  });}
  window.ldfTrack=function(name,params){window.dataLayer=window.dataLayer||[];var p=params||{};p.event=name;window.dataLayer.push(p);};
  document.addEventListener('click',function(e){var el=e.target.closest('[data-ldf-event]');if(el){window.ldfTrack(el.getAttribute('data-ldf-event'),{label:el.getAttribute('data-ldf-label')||''});}});

  /* ===== v12 mobile ===== */
  var en=document.documentElement.lang==='en';
  var mq=window.matchMedia?window.matchMedia('(max-width:600px)'):{matches:false};
  var each=function(list,fn){Array.prototype.forEach.call(list,fn);};

  /* Menu: sottovoci a fisarmonica nel pannello */
  each(document.querySelectorAll('.ldf-subtoggle'),function(b){
    b.addEventListener('click',function(){
      var d=b.closest('.ldf-drop'); if(!d) return;
      var on=d.classList.toggle('sub-open'); b.setAttribute('aria-expanded',on?'true':'false');
    });
  });

  /* Barra fissa: visibile solo dopo l'hero e mai sopra il modulo */
  var sticky=document.querySelector('.ldf-sticky');
  if(sticky&&'IntersectionObserver' in window){
    var heroSec=document.querySelector('.ldf-hero');
    var hero=heroSec?(heroSec.querySelector('.ldf-hero-cta')||heroSec):null;
    var forms=document.querySelectorAll('.ldf-form, #diagnosi, .ldf-footer');
    var heroVis=!!hero, formVis={}, n=0;
    var upd=function(){var anyForm=false;for(var k in formVis){if(formVis[k]){anyForm=true;}}sticky.classList.toggle('is-on',!heroVis&&!anyForm);};
    if(hero){new IntersectionObserver(function(es){es.forEach(function(e){heroVis=e.isIntersecting;});upd();}).observe(hero);}
    each(forms,function(f){var id='f'+(n++);formVis[id]=false;new IntersectionObserver(function(es){es.forEach(function(e){formVis[id]=e.isIntersecting;});upd();}).observe(f);});
    upd();
  } else if(sticky){sticky.classList.add('is-on');}

  /* Footer a fisarmonica */
  each(document.querySelectorAll('.ldf-footer .ldf-foldbtn'),function(b){
    var tab=function(){b.tabIndex=mq.matches?0:-1;}; tab(); if(mq.addEventListener){mq.addEventListener('change',tab);}
    b.addEventListener('click',function(){
      if(!mq.matches) return;
      var c=b.closest('.navcol'); var on=c.classList.toggle('open'); b.setAttribute('aria-expanded',on?'true':'false');
    });
  });

  /* Card in carosello: indicatore posizione */
  var setupHints=function(){
    if(!mq.matches) return;
    each(document.querySelectorAll('.ldf-grid--3:not(.ldf-grid--list),.ldf-grid--4'),function(g){
      if(g.getAttribute('data-hint')) return;
      var items=g.children; if(items.length<2) return;
      g.setAttribute('data-hint','1');
      var h=document.createElement('div'); h.className='ldf-swipehint'; h.setAttribute('aria-hidden','true');
      h.innerHTML='<span>1 / '+items.length+'</span><i><b></b></i><span>'+(en?'swipe':'scorri')+' →</span>';
      g.parentNode.insertBefore(h,g.nextSibling);
      var lbl=h.querySelector('span'), bar=h.querySelector('b');
      var sync=function(){
        var max=g.scrollWidth-g.clientWidth; var p=max>0?g.scrollLeft/max:0;
        var idx=Math.min(items.length,Math.round(p*(items.length-1))+1);
        lbl.textContent=idx+' / '+items.length;
        var w=100/items.length; bar.style.width=w+'%'; bar.style.left=(p*(100-w))+'%';
      };
      g.addEventListener('scroll',sync,{passive:true}); sync();
    });
  };
  setupHints();

  /* Gallerie: su mobile le prime 6 foto, poi "Mostra tutte" */
  each(document.querySelectorAll('.ldf-gal'),function(g){
    var figs=g.querySelectorAll('figure'); if(figs.length<=6) return;
    g.classList.add('is-capped');
    var b=document.createElement('button'); b.type='button'; b.className='ldf-btn ldf-btn-dark ldf-galmore';
    b.textContent=(en?'Show all ':'Mostra tutte le ')+figs.length+(en?' photos':' foto');
    b.addEventListener('click',function(){g.classList.remove('is-capped');b.remove();});
    g.parentNode.insertBefore(b,g.nextSibling);
  });

  /* Articoli: indice e CTA a metà */
  var prose=document.querySelector('.ldf-article .ldf-prose');
  if(prose){
    var hs=prose.querySelectorAll('h2');
    if(hs.length>=4){
      var ol=document.createElement('ol');
      each(hs,function(h,i){
        if(!h.id){h.id='s-'+(i+1)+'-'+(h.textContent||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,50);}
        var li=document.createElement('li'); var a=document.createElement('a'); a.href='#'+h.id; a.textContent=h.textContent; li.appendChild(a); ol.appendChild(li);
      });
      var toc=document.createElement('details'); toc.className='ldf-toc';
      var sm=document.createElement('summary'); sm.textContent=en?'In this article':'In questo articolo';
      toc.appendChild(sm); toc.appendChild(ol); prose.parentNode.insertBefore(toc,prose);
      toc.addEventListener('click',function(e){if(e.target.tagName==='A'){toc.open=false;}});
    }
    var art=document.querySelector('.ldf-article');
    var words=(prose.textContent||'').split(/\s+/).length;
    var link=(art&&art.getAttribute('data-cta-link'))||(en?'/en/pages/contact':'/pages/contact');
    if(words>1200&&hs.length>=4&&link){
      var mid=hs[Math.floor(hs.length/2)];
      var box=document.createElement('aside'); box.className='ldf-ctamid';
      box.innerHTML='<strong></strong><p></p><a class="ldf-btn ldf-btn-primary" data-ldf-event="article_cta_mid_click"></a>';
      box.querySelector('strong').textContent=art.getAttribute('data-cta-title')||'';
      box.querySelector('p').textContent=art.getAttribute('data-cta-text')||'';
      var a2=box.querySelector('a'); a2.href=link; a2.textContent=art.getAttribute('data-cta-label')||'';
      mid.parentNode.insertBefore(box,mid);
    }
  }
})();
